import store from "@/store";
// 1.引入 store文件
const WebSocketService = {
  
  socket: null,
  
  // 添加一个属性来存储当前发送的url信息
  currentUrl: null, 

  connect(webSocketUrl){

    // 设置 WebSocket URL
    this.currentUrl = webSocketUrl;

    this.socket = new WebSocket(this.currentUrl);

    this.socket.onopen = () => {
      console.log('WebSocket 已经建立连接');
    };

    this.socket.onmessage = (event) =>{
      const message = event.data;

      console.log("服务端返回的消息", message)

      store.dispatch('receiveWebsocketMessage', message); // 调用 Vuex action
    };


    this.socket.onclose = () =>{
      console.log('WebSocket 已经关闭');
    };

    this.socket.onerror = (error) =>{
      console.log('WebSocket连接错误的信息:', error);
    };
  },


  // 发送信息
  // sendMessage(data, callback = null){
  //   const self = this;
  //   if(self.socket && self.socket.readyState === WebSocket.OPEN){

  //     self.socket.send(JSON.stringify(data));
  //     if(callback){
  //       callback();
  //     }
  //       // 正在开启状态
  //   } else if (self.socket && self.socket.readyState === WebSocket.CONNECTING){
  //     setTimeout(() => {        // 使用箭头函数保持正确的 this 上下文
  //       self.send(data, callback); 
  //     }, 1000);
  //     // 未开启,则等待1s后重新调用
  //   }else {
  //     this.WebSocketService.connect();
  //     setTimeout(() => {
  //       self.send(data, callback); // 使用箭头函数保持正确的 this 上下文
  //     }, 1000)
  //   }
  // },


  // 发送消息
  sendMessage(fromId, toId,  fromName, contentType, content){
    let date = new Date();

    let newMessage = {
      fromId,
      toId,
      fromName,
      contentType,
      content,
      updateTime: date.toLocaleString().replace(/\//g, "-"),
    };

    // 更新消息
    store.dispatch('sendMessage',newMessage);

    if(WebSocketService.socket && WebSocketService.socket.readyState === WebSocket.OPEN){
      WebSocketService.socket.send(JSON.stringify(newMessage),() => { });
    }else {
      console.log('WebSocket is not open')
    }
  }

}

export default WebSocketService;